import BannerSetting from './BannerSetting';

export default BannerSetting;
